import { Components } from "@thisgorilla/primate-ds";
import { useState } from "react";
import styled, { useTheme } from "styled-components";
import { WithSlider } from "../../../../HOC/WithSlider";
import { useAppSelector } from "../../../../redux";
import { SliderDirection } from "../../../../redux/common";
import { JobCard } from "../../../Common";
import {
  FlexColumn,
  FlexRow,
  FlexRowCenter,
  FlexRowSpaced,
} from "../../../Common/Styles";

export const RecommendedJobsList = () => {
  const { typography } = useTheme();
  const { recommendedJobs } = useAppSelector((state) => state.me);
  const [currentStep, setCurrentStep] = useState(1);
  const [direction, setDirection] = useState("to-right" as SliderDirection);

  if (!recommendedJobs || !recommendedJobs.length) return null;

  const ITEMS_PER_SLIDE = 1;
  const TOTAL_DATA_LENGTH = recommendedJobs?.length;
  const TOTAL_SLIDES = Math.ceil(TOTAL_DATA_LENGTH / ITEMS_PER_SLIDE);
  const startIndex = (currentStep - 1) * ITEMS_PER_SLIDE;
  const endIndex = startIndex + ITEMS_PER_SLIDE;

  return (
    <MainContainer $gapInPx={10}>
      <FlexRowSpaced>
        <Components.Text
          style={{ tokenStyle: typography.Heading.S }}
          text={"Jobs for you"}
          lineHeight="line-height-400"
          fontWeight="font-weight-semibold"
        />
        <FlexRow>
          <Components.IconButton
            disabled={false}
            iconType="Sparkle"
            kind="Secondary"
            onClick={() => {}}
            size="XS"
          />
          <Components.IconButton
            disabled={false}
            iconType="ArrowRight"
            kind="Secondary"
            onClick={() => {}}
            size="XS"
          />
        </FlexRow>
      </FlexRowSpaced>
      <FlexColumn className="suggested-user-list" $gapInPx={10}>
        <WithSlider
          stepKey={`recommended-people-${currentStep}`}
          direction={direction}
        >
          <FlexColumn>
            {recommendedJobs.slice(startIndex, endIndex).map((job) => (
              <JobCard key={job.id} {...job} />
            ))}
          </FlexColumn>
        </WithSlider>
        <StepperContainer $step={currentStep}>
          {TOTAL_DATA_LENGTH > 0 && (
            <Components.Stepper
              onColor="On Transparent"
              selectedStep={currentStep}
              steps={TOTAL_SLIDES}
              setStepNumber={(value) =>
                setCurrentStep((prev) => {
                  setDirection(prev < Number(value) ? "to-right" : "to-left");
                  return Number(value);
                })
              }
              view="Gallery only"
            />
          )}
        </StepperContainer>
      </FlexColumn>
    </MainContainer>
  );
};

const MainContainer = styled(FlexColumn)`
  padding: ${({ theme }) => theme.spacing["spacing-2"].value}rem;
  border-radius: ${({ theme }) => theme.radius["radius-xs"].value}rem;
  box-shadow: ${({ theme }) => theme.boxShadows["box-shadow-s"]};
  border: 1px solid
    ${({ theme }) => theme.Color.border["ui-border-subtle"].value};
`;

const StepperContainer = styled(FlexRowCenter)<{ $step: number }>`
  .stepper-dots-container {
    width: ${({ theme }) => theme.spacing["spacing-12"].value}rem;
    .gallery-container {
      & > div {
        background: ${({ theme }) =>
          theme.Color.background.neutral["default-active"].value};
        &:nth-child(${({ $step }) => $step}) {
          background: ${({ theme }) =>
            theme.Color.background.brand.default.value};
        }
      }
    }
  }
`;
